const appRouters = [
    {
        path: '/RA',
        name: 'RaMain',
        component: () => import('@/views/code/CodeView.vue'),
        props: true
    },
    {
        path: '/M',
        name: 'MeetingMain',
        component: () => import('@/views/code/CodeView.vue'),
        props: true
    },
    {
        // path: '/W/:code?',
        path: '/W',
        name: 'WorkflowMain',
        component: () => import('@/views/code/CodeView.vue'),
        props: true
    },
]


const appMobileRouters = [
    {
        path: '/RA',
        name: 'RaMain',
        meta: {
            title: 'codeView.title'
        },
        component: () => import('@/views/code/CodeView-mobile.vue'),
        props: true
    },
    {
        path: '/M',
        name: 'MeetingMain',
        meta: {
            title: 'codeView.title'
        },
        component: () => import('@/views/code/CodeView-mobile.vue'),
        props: true
    },
    {
        // path: '/W/:code?',
        path: '/W',
        name: 'WorkflowMain',
        meta: {
            title: 'codeView.title'
        },
        component: () => import('@/views/code/CodeView-mobile.vue'),
        props: true
    },
]

module.exports = { appRouters, appMobileRouters }